import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import SmallModuleHead from '@src/pc/index/components/SmallModuleHead';
import Chip from 'Chip';
import Avatar from '@src/pc/components/Avatar';

const ShooterList = ({ shooteHead, shootOld, shootNew }) => {
    const shootOldList = shootOld?.results || [];
    const shootNewList = shootNew?.results || [];
    const shootInitList = [{}, {}, {}, {}, {}];
    let shootList = shootNewList.length > 0 ? shootNewList : shootOldList;

    shootList = shootInitList.map((item, index) => {
        return shootList[index];
    });

    return (
        <div className={styles.shooterList}>
            <Chip id="260478" type="struct" title="射手榜头" content={shooteHead}>
                <SmallModuleHead />
            </Chip>
            <div className={styles.shooterListBox}>
                <table className={styles.shooterListTable}>
                    <tbody>
                        {shootList.map((item, index) => {
                            return (
                                <tr key={index} className={styles.shooterListTr}>
                                    <td className={styles.shooterListNum}>{index + 1}</td>
                                    <td className={styles.shooterListPicBox}>
                                        <div className={styles.shooterListPicBg}>
                                            {item?.icon && (
                                                <Avatar
                                                    className={styles.shooterListPic}
                                                    content={{ url: item.icon }}
                                                />
                                            )}
                                        </div>
                                    </td>
                                    <td className={styles.shooterListNameBox}>
                                        <div className={styles.shooterListName}>{item?.name || '-'}</div>
                                    </td>
                                    <td>
                                        <div className={styles.shooterListCountry}>{item?.country || '-'}</div>
                                    </td>
                                    <td>
                                        <div className={styles.shooterListScore}>{item?.jinqiu || '-'}</div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

ShooterList.propTypes = {
    shooteHead: PropTypes.object,
    shootOld: PropTypes.object,
    shootNew: PropTypes.object,
};

export default errorBoundary(ShooterList);
